/* eslint-disable multiline-ternary */
import styled, { css } from 'styled-components';

const getSectionVariantBackgroundColor = (theme, variant) => {
  if (variant === 'primary') {
    return theme.colors.primary.blue;
  }
  if (variant === 'secondary') {
    return theme.colors.neutral.grey95;
  }
  // If a hex color code is passed in, use that. (Design frequently uses several grey shades)
  if (variant && variant !== 'tertiary') {
    return variant;
  }
  // tertiary (Default)
  return theme.colors.neutral.white;
};

const getSectionVariantColor = (theme, variant) => {
  if (variant === 'primary') {
    return theme.colors.neutral.white;
  }
  // tertiary and secondary
  return theme.colors.neutral.grey29;
};

// eslint-disable-next-line import/prefer-default-export
export const GeneralSection = styled.section`
  && {
    ${({ theme, variant }) => {
    const desktop = theme.useMediaQuery(theme.breakpoints.up('medium'));
    return css`
        padding-top: ${desktop
    ? theme.spacing(12.5).rem()
    : theme.spacing(10).rem()};
        padding-bottom: ${desktop
    ? theme.spacing(12.5).rem()
    : theme.spacing(10).rem()};
        max-width: unset;
        background-color: ${getSectionVariantBackgroundColor(theme, variant)};
        color: ${getSectionVariantColor(theme, variant)};
      `;
  }}
  }
`;
